import axios from "axios";
import type {
  PaginatedResponse,
  PaginatedTableQuery,
} from "../../../../components/tables/CustomPaginatedTable/types";
import type { DigitalAsset } from "../types";

const API_BASE_URL = process.env.REACT_APP_API_BASEURL + "/DigitalAssets";

export interface GetDigitalAssetsParams extends PaginatedTableQuery {
  officeCode?: string;
  recordIds?: string;
}

export const getDigitalAssets = async (
  params: GetDigitalAssetsParams,
): Promise<PaginatedResponse<DigitalAsset>> => {

  const response = await axios.get<PaginatedResponse<DigitalAsset>>(
    API_BASE_URL,
    { params },
  );

  return response.data;
};
